// no-op

module.exports = function() {
  return function() {}
}
